import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';

export default function Cabecalho({ buttonList }) {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const buttons = buttonList || [
    { titulo: t('nav.home'), href: '/' },
    { titulo: t('nav.results'), href: '/portifolio' },
    { titulo: t('nav.plans'), href: '/planos' },
    { titulo: t('nav.contact'), href: '/contato' },
  ];

  const closeMenu = (event, action) => {
    setMenuOpen(false);
    if (typeof action === 'function') action(event);
  };

  return (
    <nav className="navbar navbar-default qt-navbar">
      <div className="container qt-navbar-inner">
        <div className="navbar-header qt-navbar-header">
          <Link className="navbar-brand qt-navbar-brand" to="/" aria-label={t('nav.brandHome')}>
            <img
              src={require('../../img/Quanum_trades_ico.jpg')}
              width={35}
              height={35}
              alt="Quantum Trades"
              className="qt-header-logo"
            />
            <span className="qt-brand-name">Quantum Trades</span>
          </Link>

          <button
            type="button"
            className="qt-navbar-toggle"
            aria-label={menuOpen ? t('nav.closeMenu') : t('nav.openMenu')}
            aria-expanded={menuOpen}
            aria-controls="qt-public-menu"
            onClick={() => setMenuOpen((current) => !current)}
          >
            <span aria-hidden="true">{menuOpen ? '\u00d7' : '\u2630'}</span>
          </button>
        </div>

        <div
          id="qt-public-menu"
          className={`navbar-collapse qt-navbar-menu ${menuOpen ? 'is-open' : ''}`}
        >
          <ul className="nav navbar-nav navbar-right qt-navbar-list">
            {buttons.map((btn) => (
              <li key={`${btn.titulo}-${btn.href}`}>
                {String(btn.href || '').startsWith('/') ? (
                  <Link to={btn.href} onClick={(event) => closeMenu(event, btn.action)}>
                    {btn.titulo}
                  </Link>
                ) : (
                  <a href={btn.href} onClick={(event) => closeMenu(event, btn.action)}>
                    {btn.titulo}
                  </a>
                )}
              </li>
            ))}
            <li className="qt-language-item">
              <LanguageSwitcher />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
